import { createBrowserHistory } from 'history';

/**
 * browserHistory provides shared access to manipulate the current url, allowing components to
 * navigate dynamically when needed.
 */
export const browserHistory = createBrowserHistory();
